// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"256":"c4004bbb","617":"ac7ce606"}[chunkId] + ".chunk.js";
};